import { MDCSelect } from '@material/select';
import { MDCTextField } from '@material/textfield';
import { MDCRipple } from '@material/ripple';
import { MDCSnackbar } from '@material/snackbar';
import { MDCFormField } from '@material/form-field';
import { MDCRadio } from '@material/radio';
import { MDCSwitch } from '@material/switch';
import { MDCDialog } from '@material/dialog';
import { MDCList } from '@material/list';
import { MDCCheckbox } from '@material/checkbox';

import autoInit from '@material/auto-init';

import PushBar from './pushbar';
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

require('./bootstrap');
require('./bugsnag');

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

autoInit.register('MDCSelect', MDCSelect);
autoInit.register('MDCTextField', MDCTextField);
autoInit.register('MDCRipple', MDCRipple);
autoInit.register('MDCSnackbar', MDCSnackbar);
autoInit.register('MDCFormField', MDCFormField);
autoInit.register('MDCRadio', MDCRadio);
autoInit.register('MDCSwitch', MDCSwitch);
autoInit.register('MDCDialog', MDCDialog);
autoInit.register('MDCList', MDCList);
autoInit.register('MDCCheckbox', MDCCheckbox);
autoInit();

new PushBar({
    overlay: true
});

require('./components/Calendar');
require('./components/CookieBar');
